"use client";

import { ReactNode } from "react";
import { useLanguage } from "../../context/LanguageContext";
import { Header } from "../Header";
import { PageTitle } from "../PageTitle";
import SiteFooter from "../SiteFooter";
import {
  bodyTextClass,
  cardHeadingClass
} from "../typography";

type CardProps = {
  title: string;
  children: ReactNode;
};

function InfoCard({ title, children }: CardProps): JSX.Element {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h2 className={cardHeadingClass}>{title}</h2>
      <div className={`mt-3 ${bodyTextClass}`}>{children}</div>
    </div>
  );
}

export default function TermsPage(): JSX.Element {
  const { t } = useLanguage();
  const c = t.termsPage;
  const contactEmail = t.common.footer.email;

  return (
    <div className="flex min-h-screen flex-col" dir={t.common.dir} lang={t.common.lang}>
      <Header />
      <main className="flex-1">
        <section className="scroll-mt-28 py-16">
          <div className="mx-auto max-w-5xl px-4">
            <PageTitle
              label={c.label}
              title={c.title}
              intro={c.intro}
              lastUpdated={c.lastUpdated}
            />

            <div className="grid gap-6">
              <InfoCard title={c.informationalTitle}>
                <p className="text-start rtl:text-right">{c.informationalBody}</p>
              </InfoCard>

              <InfoCard title={c.adviceTitle}>
                <p className="text-start rtl:text-right">{c.adviceBody}</p>
              </InfoCard>

              <InfoCard title={c.ipTitle}>
                <p className="text-start rtl:text-right">{c.ipBody}</p>
              </InfoCard>

              <InfoCard title={c.liabilityTitle}>
                <p className="text-start rtl:text-right">{c.liabilityBody}</p>
              </InfoCard>

              <InfoCard title={c.linksTitle}>
                <p className="text-start rtl:text-right">{c.linksBody}</p>
              </InfoCard>

              <InfoCard title={c.changesTitle}>
                <p className="text-start rtl:text-right">{c.changesBody}</p>
              </InfoCard>

              <InfoCard title={c.lawTitle}>
                <p className="text-start rtl:text-right">{c.lawBody}</p>
              </InfoCard>

              <InfoCard title={c.contactTitle}>
                <p className="text-start rtl:text-right">
                  {c.contactBody}{" "}
                  <a
                    href={`mailto:${contactEmail}`}
                    className="text-sky-700 hover:text-sky-800 dark:text-sky-400 dark:hover:text-sky-300"
                  >
                    {contactEmail}
                  </a>
                  .
                </p>
              </InfoCard>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
